import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import { initLenis } from "@/lib/smooth";
import Home from "@/pages/Home";
import ArtworkDetail from "@/pages/ArtworkDetail";
import Admin from "@/pages/Admin";
import SectionPage from "@/pages/SectionPage";
import NotFound from "@/pages/NotFound";
import { PAGES } from "@/lib/site";

function Shell() {
  const { theme } = useTheme();
  useEffect(() => {
    initLenis();
  }, []);
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          {Object.entries(PAGES).map(([key, page]) => (
            <Route key={key} path={page.path} element={<SectionPage key={key} section={key} />} />
          ))}
          <Route path="/artwork/:id" element={<ArtworkDetail />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme={theme} position="bottom-right" />
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <Shell />
    </ThemeProvider>
  );
}
